export default function FooterTransparent() {
  return (
    <div className="absolute bottom-6 right-9">
      <img src="/logo/filled_footer.png" alt="test" className="h-[50px]" />
    </div>
  )
}
